import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
import { formatAppDate } from '../utils/app-date-formatter';
export interface TenantDateFormats {
  dateFormat: string;
  timeFormat: string;
  dateTimeFormat: string;
}
export const defaultTenantDateFormats: TenantDateFormats = {
  dateFormat: 'dd-MM-yyyy',
  timeFormat: 'HH:mm',
  dateTimeFormat: 'dd-MM-yyyy HH:mm'
};
@Injectable({ providedIn: 'root' })
export class TenantFormattingService {
  private readonly http = inject(HttpClient);
  readonly formats = signal<TenantDateFormats>(defaultTenantDateFormats);
  private request?: Subscription;
  load(): void {
    this.request?.unsubscribe();
    this.request = this.http.get<TenantDateFormats>(`${environment.apiUrl}/api/settings/formats`).subscribe({
      next: formats => this.formats.set(formats),
      // Keep the last successful formats during a temporary network failure.
      error: () => { }
    });
  }
  reset(): void {
    this.request?.unsubscribe();
    this.formats.set(defaultTenantDateFormats);
  }
  format(value: Date | string | number | null | undefined, kind: 'date' | 'time' | 'dateTime' | 'dayKey' = 'date'): string {
    const formats = this.formats();
    const formatByKind = {
      dayKey: 'yyyy-MM-dd',
      time: formats.timeFormat,
      dateTime: formats.dateTimeFormat,
      date: formats.dateFormat
    };
    return formatAppDate(value, formatByKind[kind]);
  }
}
